import useDataGridStore from "stores/dataGridStore";
import { useEffect, useState } from "react";
import SelectBrand from "./selectBrand";
import LockedMenuModal from "../lockedFilterComps/lockedMenuModal";
import LockedMenuOverlay from "../lockedFilterComps/lockedMenuOverlay";

const SelectBrandFilter = () => {
  const { updateStack, dataSourceIsLoading } = useDataGridStore();
  const [lockedMenu, setLockedMenu] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    setLockedMenu((prevLockedMenu) => {
      const currentUpdateStackLength = updateStack ? updateStack?.length : 0;
      if (prevLockedMenu && currentUpdateStackLength === 0) {
        return false;
      }
      if (!prevLockedMenu && currentUpdateStackLength > 0) {
        return true;
      }
      return prevLockedMenu;
    });
  }, [updateStack]);

  const handleUnlockClick = () => {
    setIsModalVisible(true);
  };

  const confirmUnlock = () => {
    setLockedMenu(false);
    setIsModalVisible(false);
  };

  const cancelUnlock = () => {
    setIsModalVisible(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <LockedMenuOverlay
        handleUnlockClick={handleUnlockClick}
        lockedMenu={lockedMenu}
      />
      <SelectBrand isDisabled={lockedMenu || dataSourceIsLoading} />
      <LockedMenuModal
        isModalVisible={isModalVisible}
        confirmUnlock={confirmUnlock}
        cancelUnlock={cancelUnlock}
      />
    </div>
  );
};

export default SelectBrandFilter;
